export enum TundishComponents {
	PermanentLining = 301,
	Nozzle = 302,
	StopperRod = 303,
	PouringTube = 304,
	TDryVibe = 305,
	ImpactPad = 306,
	Deskull = 307,
	NQCAlignment = 308,
	GateInspection = 309,
	SignOffTundish = 310,
	SignOffCaster = 311,
	Cassette = 312,
	SERT = 313,
	WestLid = 314,
	EastLid = 315,
	NQCBoltsTightening = 316,
}
